import React from 'react';
import * as moment from 'moment-timezone';
import { formatTimeFromPresent } from '../../shared/dateUtils';

interface State {
  activeItem: any,
  marqueeItemIndex: number,
  marqueeIntervalStarted: boolean,
}

interface Props {
  marqueeItems: any,
  loading: any,
  setCurrentItem: any,
  clickedLiveStream: any,
  wrapperStyle: string,
}

class MarqueeBanner extends React.Component<Props, State> {
  interval: any;
  constructor(props) {
    super(props);
    this.state = {
      activeItem: null,
      marqueeItemIndex: 0,
      marqueeIntervalStarted: false
    };
    this.setCurrentItem = this.setCurrentItem.bind(this);
    this.clickedLiveStream = this.clickedLiveStream.bind(this);
    this.activateMarqueeItems = this.activateMarqueeItems.bind(this);
  }

  componentDidMount() {
    this.activateMarqueeItems();
  }

  componentDidUpdate() {
    this.activateMarqueeItems();
  }

  activateMarqueeItems() {
    if(this.props.marqueeItems && this.props.marqueeItems.length) {
      if(this.state.activeItem == null) {
        this.setCurrentItem();
      }
      if(!this.state.marqueeIntervalStarted) {
        this.interval = setInterval(() => {
          this.setCurrentItem();
        }, 20000)
        this.setState({marqueeIntervalStarted: true});
      }
    }
  }

  setCurrentItem() {
    let updatedIndex = 0;
    let currentIndex = this.state.marqueeItemIndex;
    if(this.state.marqueeItemIndex != this.props.marqueeItems.length-1) {
      updatedIndex = this.state.marqueeItemIndex+1;
    }
    this.setState({
      activeItem: this.props.marqueeItems[currentIndex],
      marqueeItemIndex: updatedIndex
    })
  }

  getTopText(item) {
    let startsAt = moment.parseZone(item.iso_starts_at);
    let endsAt = moment.parseZone(item.iso_ends_at);
    if(startsAt.isAfter()) {
      return (
        <div className="fs-xs fw-sb cs-color-black-70">
          NEXT LIVESTREAM AT {formatTimeFromPresent(item.iso_starts_at)}
        </div>
      )
    } else if(startsAt.isSameOrBefore() && endsAt.isAfter()) {
      return (
        <div className="fs-xs fw-sb cs-live-blue">
          <i className="fas fa-video pr1"></i>
          LIVE NOW UNTIL {formatTimeFromPresent(item.iso_ends_at)}
        </div>
      )
    } else {
      return (
        <div className="fs-xs fw-sb cs-color-black-70">
          LIVESTREAM ENDED AT {formatTimeFromPresent(item.iso_ends_at)}
        </div>
      )
    }
  }

  clickedLiveStream(e) {
    this.props.clickedLiveStream(e);
  }

  componentWillUnmount() {
    if (this.interval) clearInterval(this.interval);
  }

  render() {
    if(this.state.activeItem) {
      return (
        <div
          className={this.props.wrapperStyle}
          data-live-stream-id={this.state.activeItem.id}
          data-modal-button-type="dismiss"
          onClick={this.clickedLiveStream}
        >
          <div className="top-live-stream-text fs-xs">
            {this.getTopText(this.state.activeItem)}
          </div>
          <div className="bottom-live-stream-text-wrapper">
            <div className="bottom-live-stream-text fw-b fs-md marquee-text">
              {this.state.activeItem.name}
            </div>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }
}

export default MarqueeBanner;
